import {isValid as isValidDate} from '@gravity-ui/date-utils';

const isValidStringDate = (value: unknown): value is string => {
    return (
        typeof value === 'string' &&
        value.split('-').filter((str) => str !== '').length === 3 &&
        isValidDate(value)
    );
};
export default isValidStringDate;
